import api from "api";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { ReferralTrackingParams, ReferralTrackingResponse, Referral } from "./types";
import buildQueryString from "./buildQueryString";

// Uses api.call() until rswag specs are deployed and typegen regenerated.
// API returns medical_referral_id instead of id
type RawReferral = Omit<Referral, "id"> & { id?: number; medical_referral_id?: number };

const useReferralTracking = (params: ReferralTrackingParams) => {
  return useQuery<ReferralTrackingResponse, Error>(
    queryKeys.ukReferralTracking(params),
    async () => {
      const qs = buildQueryString(params);
      const response = await api.call(`/uk/referral_tracking${qs}`);
      const data = await response.json();
      const totalCount = response.headers.get("Total-Count");
      const raw: RawReferral[] = Array.isArray(data) ? data : (data.items ?? []);
      const items: Referral[] = raw.map((r) => {
        const id = r.id ?? r.medical_referral_id ?? 0;
        return {
          ...r,
          id,
          rowKey: `${id}-${r.cic_pathway_ids || ""}`,
        };
      });
      return {
        items,
        total_count: totalCount ? parseInt(totalCount, 10) : data.total_count ?? 0,
      };
    },
    {
      keepPreviousData: true,
    }
  );
};

export default useReferralTracking;
